<template>
    <div
        v-if="alerts.length"
        class="alertGroup"
    >
        <transition name="fade">
            <div
                v-if="isOpen"
                class="alertGroup__screen"
                :class="{'-active' : initialModeComplete }"
                @click="onScreenClicked"
            />
        </transition>
        <transition-group
            ref="panel"
            name="staggered-fade"
            class="alertGroup__panel container"
            :class="{'-isOpen' : isOpen }"
            tag="div"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
        >
            <AlertPill
                v-for="(alert, index) in activeAlerts"
                :key="alert.id"
                ref="alerts"
                :data-index="index"
                v-bind="alert"
                @toggle-alert-pill="onPillClicked"
            />
        </transition-group>
    </div>
</template>

<script>
import { TweenMax } from 'gsap'
import AlertPill from './AlertPill'
import { mapMutations, mapState } from 'vuex'

export default {
    components: {
        AlertPill,
    },

    computed: {
        ...mapState({
            alerts: 'alerts',
            isOpen: 'alertPanelOpen',
            initialModeComplete: 'initialModeComplete',
            warningActive: 'warningActive',
        }),

        activeAlerts () {
            return this.isOpen ? this.alerts : []
        },
    },

    watch: {
        activeAlerts (value) {
            if (value.length) {
                this.$nextTick(() => {
                    this.$refs.alerts[0].$el.querySelector('button').focus()
                })
            }
        },
    },

    methods: {
        ...mapMutations({
            toggleAlerts: 'TOGGLE_ALERT_PANEL',
            openAlerts: 'SET_ALERT_PANEL_OPEN',
            closeAlerts: 'SET_ALERT_PANEL_CLOSED',
            removeWarning: 'REMOVE_WARNING',
            updateInitial: 'UPDATE_INITIAL',
        }),

        onScreenClicked () {
            this.toggleAlerts()
            if (!this.initialModeComplete) {
                this.updateInitial({ hasClickedScreen: true })
            }
        },

        onPillClicked () {
            this.updateInitial({ hasOpenedPill: true })
            if (this.warningActive) {
                this.removeWarning()
            }
        },

        // TRANSITIONS ======================================
        beforeEnter () {
            this.$refs.panel.$el.style.overflowY = null
        },

        enter (el, done) {
            TweenMax.fromTo(el,
                {
                    opacity: 0,
                    scale: 0,
                    y: -300,
                },
                {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                    ease: 'back.out(1.2)',
                    duration: 0.75,
                    stagger: () => el.dataset.index * 0.1,
                    onComplete: () => {
                        this.$refs.panel.$el.style.overflowY = 'hidden'
                        done()
                    },
                }
            )
        },

        leave: function (el, done) {
            TweenMax.fromTo(el,
                {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                },
                {
                    opacity: 0,
                    scale: 0,
                    y: -300,
                    ease: 'back.in(1)',
                    duration: 0.5,
                    onStart: () => {
                        this.$refs.panel.$el.style.overflowY = 'hidden'
                    },
                    onComplete: done,
                }
            )
        },
    },
}
</script>
